<template>
  <v-radio-group v-model="selectedWebinar" @change="chooseWebinar">
    <ul class="webinar-list m-0 d-flex flex-column">
      <SingleWebinar
        v-for="webinar in webinars"
        :key="webinar.webinar_id"
        :webinar="webinar"
        ref="webinar"
        @choose-selected-webinar="chooseSelectedWebinar"
      />
    </ul>
  </v-radio-group>
</template>

<script>
import SingleWebinar from "./SingleWebinar.vue";

export default {
  name: "WebinarList",
  components: {
    SingleWebinar,
  },
  props: {
    webinars: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedWebinar: null,
    };
  },
  methods: {
    /**
     * Choose a webinar based on its id and save it on state
     * @param id number
     * @returns void
     */
    chooseWebinar(id) {
      this.$store.dispatch("saveWebinar", id);
    },

    /**
     * Choose selected webinar from state
     * @param id number
     */
    chooseSelectedWebinar(id) {
      this.selectedWebinar = id;
    },
  },
};
</script>

<style lang="scss" scoped>
.webinar-list {
  list-style: none;
  gap: 8px;
}
</style>
